import { AxiosResponse } from 'axios';
import {
  all,
  call,
  put,
  takeLatest,
  takeEvery,
  select,
} from 'redux-saga/effects';
import {
  deleteDraft,
  getClaimById,
  getClaims,
  getClaimStatus,
  getStates,
  getStatusActionById,
  getStepsByClaimId,
  getTRFREM,
  searchClaims,
} from 'services/claimsService';
import { ApplicationState } from 'store/store.inteface';
import { ApiResponse } from 'types/ApiResponse';
import { SagasAction } from 'types/SagasAction';

import {
  getClaimsActive,
  getClaimsCompleted,
  getClaimStatusCompleted,
  getStatesCompleted,
  invalidActiveClaimsAction,
  searchClaimsCompleted,
  setClaimByIdAction,
  setClaimsByStatus,
  setStatusActionsAction,
  setStepsByClaimId,
  setTrfRemAction,
} from './actions';
import {
  CLAIMS_TYPES,
  ClaimType,
  GetClaims,
  IClaim,
  States,
  Status,
  StatusAction,
  StepClaimStatus,
  TrfRem,
} from './types';

export function* searchClaimsSaga() {
  try {
    const { stores, cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data } = yield call(searchClaims, cpId, stores[0]?.code);
    yield put(searchClaimsCompleted(data.response));
  } catch (err) {
    console.log(err);
  }
}

export function* getClaimsByTypeSaga({ payload }: SagasAction<GetClaims>) {
  try {
    const { stores, cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data }: AxiosResponse<ApiResponse<ClaimType>> = yield call(
      getClaims,
      cpId,
      stores[0]?.code,
      payload,
    );

    if (payload.type === 'active') yield put(getClaimsActive(data.response));
    else yield put(getClaimsCompleted(data.response));
  } catch (err) {
    console.log(err);
  }
}

export function* getClaimsByStatusSaga({ payload }: SagasAction<GetClaims>) {
  try {
    const { stores, cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data }: AxiosResponse<ApiResponse<ClaimType>> = yield call(
      getClaims,
      cpId,
      stores[0]?.code,
      payload,
    );
    yield put(setClaimsByStatus(data.response.results, payload.status));
  } catch (err) {
    console.log(err);
  }
}

export function* getClaimStatusSaga() {
  try {
    const { stores, cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data }: AxiosResponse<ApiResponse<Status[]>> = yield call(
      getClaimStatus,
      cpId,
      stores[0]?.code,
    );
    yield put(getClaimStatusCompleted(data.response));
  } catch (err) {
    console.log(err);
  }
}

export function* getStepsByIdSaga({ payload }: SagasAction<string>) {
  try {
    const { stores, cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data }: AxiosResponse<ApiResponse<StepClaimStatus[]>> = yield call(
      getStepsByClaimId,
      payload,
      cpId,
      stores[0]?.code,
    );
    yield put(setStepsByClaimId(data.response));
  } catch (err) {
    console.log(err);
  }
}

export function* getTrfRemByIdSaga({ payload }: SagasAction<string>) {
  try {
    const { stores, cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data }: AxiosResponse<ApiResponse<TrfRem[]>> = yield call(
      getTRFREM,
      cpId,
      stores[0]?.code,
      payload,
    );
    yield put(setTrfRemAction(data.data));
  } catch (err) {
    console.log(err);
  }
}

export function* getClaimByIdSaga({ payload }: SagasAction<string>) {
  try {
    const { stores, cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data }: AxiosResponse<ApiResponse<IClaim>> = yield call(
      getClaimById,
      payload,
      cpId,
      stores[0]?.code,
    );
    yield put(setClaimByIdAction(data.response));
  } catch (err) {
    console.log(err);
  }
}

export function* getStatusActionByIdSaga({ payload }: SagasAction<string>) {
  try {
    const { stores, cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data }: AxiosResponse<ApiResponse<StatusAction>> = yield call(
      getStatusActionById,
      payload,
      cpId,
      stores[0].code,
    );
    yield put(setStatusActionsAction(data.response));
  } catch (err) {
    console.log(err);
  }
}

export function* getStatesSaga() {
  try {
    const { stores, cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data }: AxiosResponse<ApiResponse<States[]>> = yield call(
      getStates,
      cpId,
      stores[0]?.code,
    );
    yield put(getStatesCompleted(data.response));
  } catch (err) {
    console.log(err);
  }
}

export function* deleteDraftSaga({ payload }: SagasAction<string>) {
  try {
    const { stores, cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    yield call(deleteDraft, payload, cpId, stores[0].code);

    yield put(invalidActiveClaimsAction());
  } catch (err) {
    console.log(err);
  }
}

export default all([
  takeLatest(CLAIMS_TYPES.SEARCH_CLAIMS_REQUEST, searchClaimsSaga),
  takeEvery(CLAIMS_TYPES.GET_CLAIMS_BY_TYPE_REQUEST, getClaimsByTypeSaga),
  takeEvery(CLAIMS_TYPES.GET_CLAIMS_BY_STATUS_REQUEST, getClaimsByStatusSaga),
  takeEvery(CLAIMS_TYPES.GET_STATUS_REQUEST, getClaimStatusSaga),
  takeEvery(CLAIMS_TYPES.GET_STATES_REQUEST, getStatesSaga),
  takeEvery(CLAIMS_TYPES.DELETE_DRAFT, deleteDraftSaga),
  takeEvery(CLAIMS_TYPES.GET_STEPS_BY_CLAIM_ID, getStepsByIdSaga),
  takeEvery(CLAIMS_TYPES.GET_CLAIM_BY_ID, getClaimByIdSaga),

  takeEvery(CLAIMS_TYPES.GET_STATUS_ACTIONS, getStatusActionByIdSaga),

  takeEvery(CLAIMS_TYPES.GET_TRF_REM_BY_CLAIM_ID, getTrfRemByIdSaga),
]);
